// Copyright (c) 2021, 37.78 Tecnologia Ltda. All rights reserved.

const noop = () => {};

export { noop };
